import React from "react";
import { Header, Footer,  } from "../../Components/Common";
// import { useMediaQuery } from 'react-responsive';
import {  useSelector } from 'react-redux';

const Desktoplayout = ({ children }) => {
    // const isMobile = useMediaQuery({ query: '(max-width: 576px)' });
    const loading = useSelector((state) => state.Globalslice.loading);

    return (
        <div>
            <Header />

            {loading ? (
                <div className="loader-wrapper">
                    <div class="spinner-border text-primary" role="status">

                    </div>
                </div>
            )
                :
                <div>{children}</div>
            }

            <Footer />
        </div>
    );
};

export default Desktoplayout;